<template>
    <AppModal :name="name"
              :beforeClose="beforeClose"
              :beforeOpen="beforeOpen"
              :onEnterKeyPress="save"
              :opened="opened"
              width="500">

        <template slot="header">
            Add section
        </template>

        <template slot="content">
            <AppRadioButtonsGroup
                label="label"
                trackBy="key"
                :value="sectionTypeKey"
                :options="Object.values(sectionTypes)"
                @update="onSectionTypeToggle" class="mb-3"/>

            <template v-if="sectionTypeKey === sectionTypes.system.key">
                <div v-if="availableSystemSections.length === 0" class="text-muted">
                    All system sections added. <br>
                    Use custom sections to expand the form
                </div>
                <div v-else class="text-left">
                    <label for="section">Section</label>
                    <multiselect
                        :value="availableSystemSections.find(s => s.key === section.key)"
                        :options="availableSystemSections"
                        @input="onSystemSectionSelect"
                        id="section"
                        class="multiselect-md"
                        track-by="key"
                        label="label">
                    </multiselect>
                </div>
            </template>
            <div v-else class="text-left">
                <label for="sectionLabel">Label</label>
                <input v-model.trim="section.label"
                       @input="vuelidateDelayTouch($v.section.label, touchMap)"
                       autofocus
                       type="text"
                       ref="sectionLabel"
                       id="sectionLabel"
                       class="form-control"
                       placeholder="Section label">
                <small v-if="$v.section.label.$error" class="form-text text-danger">
                    <span v-if="!$v.section.label.required">This field is required</span>
                </small>
            </div>
        </template>

        <template slot="actions">
            <div class="text-right">
                <button @click="$modal.hide(name)" class="btn btn-link d-inline-block">
                    Close
                </button>
                <button v-loading.btn="isLoading"
                        @click="save"
                        :disabled="disabledAddBtn"
                        class="btn btn-primary d-inline-block">
                    Add
                </button>
            </div>
        </template>

    </AppModal>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import AppRadioButtonsGroup from '../../../../../components/shared/AppRadioButtonsGroup'
import {defaultSystemSectionsList, getEmptySectionModel} from '../../../../../types/document-viewer/section'

export default {
    name: 'AddFormSection',
    components: {AppRadioButtonsGroup},
    props: {
        name: {
            type: String,
            required: true
        },
        sections: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            touchMap: new WeakMap(),
            section: getEmptySectionModel(),

            sectionTypeKey: 'system',
            sectionTypes: {
                system: {
                    label: 'System',
                    key: 'system'
                },
                custom: {
                    label: 'Custom',
                    key: 'custom'
                }
            },

            isLoading: false
        }
    },
    validations: {
        section: {
            label: {required}
        }
    },
    computed: {
        availableSystemSections() {
            return defaultSystemSectionsList.filter(s => !this.sections.some(section => section.key === s.key))
        },

        disabledAddBtn() {
            return (this.sectionTypeKey === this.sectionTypes.system.key && this.availableSystemSections.length === 0) ||
                (this.sectionTypeKey === this.sectionTypes.custom.key && !this.section.label)
        }
    },
    methods: {
        beforeClose() {
            Object.assign(this.$data, this.$options.data.apply(this))
            this.$v.$reset()
        },

        beforeOpen({params}) {
        },

        opened() {
        },

        async onSectionTypeToggle(key) {
            this.sectionTypeKey = key
            this.section = getEmptySectionModel()
            if (key === this.sectionTypes.custom.key) {
                await this.$nextTick()
                this.focusLabelInput()
            }
        },

        onSystemSectionSelect(s) {
            this.section = {...s}
        },

        focusLabelInput() {
            this.$refs.sectionLabel.focus()
        },

        save() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }
            this.$emit('add', {
                ...this.section,
                visible: true,
                expandable: true,
                order: this.sections && this.sections.length !== 0 ? (_.maxBy(this.sections, 'order').order || 0) : 0
            })
            this.$modal.hide(this.name)
        }
    }
}
</script>

<style scoped>

</style>
